<div class="mb-search-component">
  <ng-container>
    <div class="mb-search-box">
      <div class="row no-gutters">

        <div class="col-12 mb-search-box-container">
          <div class="mb-search-box-input-div">
            <input [mbFocus]="isInitialFocused"
                   class="mb-search-box-input"
                   data-cy="mb-search-box-input"
                   autocomplete="off"
                   #searchInput aria-label="search"
                   (focus)="open(); toggleInputFocus(true)"
                   (click)="open()"
                   (input)="search(searchInput.value)"
                   (blur)="close($event); toggleInputFocus(false)"
                   (keydown.escape)="close($event)"
                   (keydown.enter)="close($event, true); launchSearchEvents($event, searchInput.value)"
                   (keydown.arrowup)="focusPreviousChild($event); toggleInputFocus(true)"
                   (keydown.arrowdown)="focusNextChild($event); toggleInputFocus(true)"
                   [maxLength]="searchTermCharLimit"
                   value="{{ chosenWord }}"
                   id="searchInput"
                   placeholder="{{'mainSearchBox.searchForArticle' | mbTranslate}}"/>
            <button *ngIf="searchInput.value && !isCategoryPage"
                    data-cy="mb-search-box-clear-button"
                    class="btn btn-block btn-secondary mb-search-box-btn"
                    type="button"
                    (click)="clear(searchInput)">
                    <span>{{'mainSearchBox.clear' | mbTranslate}}</span>
            </button>
            <button *ngIf="searchInput.value && isCategoryPage"
                    data-cy="mb-search-box-reset-button"
                    class="btn btn-block btn-secondary mb-search-box-btn"
                    type="button"
                    (click)="reset(searchInput, $event)">
                    <span>{{'mainSearchBox.reset' | mbTranslate}}</span>
            </button>
            <img src="../../../../../assets/images/Icon_search.svg"
                 class="pr-2 search mb-search-box-search-icon"
                 alt="Search Icon"
                 title="Search Icon"
                 aria-label="Search Icon"
                 data-cy="mb-search-box-search-icon"
                 id="searchIconIDUsedForSearching"
                 (mousedown)="avoidReopen($event); launchSearchEvents($event, searchInput.value)"
                 (keydown.enter)="avoidReopen($event)"
                 (click)="close($event, true)">
          </div>
        </div>

        <div *ngIf="!isCategoryPage"
             class="col-12">
          <div *ngIf="results$ | async as result"
               [ngClass]="[isFocused ? 'is-focused' : '', 'results']"
               (click)="close($event, true); toggleInputFocus(false)">
            <div *ngIf="result.message"
                 class="message"
                 [innerHTML]="result.message">
            </div>

            <ul class="suggestions">
              <li *ngFor="let suggestion of result.suggestions">
                <a [innerHTML]="suggestion"
                   [routerLink]="null"
                   (keydown.arrowup)="focusPreviousChild($event); toggleInputFocus(true)"
                   (keydown.arrowdown)="focusNextChild($event); toggleInputFocus(true);"
                   (keydown.enter)="close($event, true); toggleInputFocus(false)"
                   (keydown.escape)="close($event, true); toggleInputFocus(false)"
                   (blur)="close($event); toggleInputFocus(false)"
                   (mousedown)="preventDefault($event)"
                   (click)="close($event, true); dispatchSuggestionEvent({ freeText: searchInput.value, selectedSuggestion: suggestion, searchSuggestions: result.suggestions });
                            ; toggleInputFocus(false); updateChosenWord(suggestion); navigateToSearchPage(suggestion) //noinspection ValidateTypes"
                   data-cy="mb-search-box-suggestions">
                </a>
              </li>
            </ul>

            <ul class="products"
                data-cy="mb-search-box-results-products"
                *ngIf="result.products">
              <li *ngFor="let product of result.products">
                <a [routerLink]="getRouterLink(product.url)"
                   [fragment]="getFragment(product.url)"
                   [class.has-media]="config.displayProductImages"
                   [mbProductClick]="product"
                   (keydown.arrowup)="focusPreviousChild($event); toggleInputFocus(true)"
                   (keydown.arrowdown)="focusNextChild($event); toggleInputFocus(true)"
                   (keydown.enter)="close($event, true); toggleInputFocus(false)"
                   (keydown.escape)="close($event, true); toggleInputFocus(false)"
                   (blur)="close($event); toggleInputFocus(false)"
                   (mousedown)="preventDefault($event)"
                   (click)="dispatchProductEvent({ freeText: searchInput.value, productCode: product.code }); close($event, true); toggleInputFocus(false)"
                   data-cy="mb-search-box-products">
                  <cx-media *ngIf="config.displayProductImages"
                            [container]="product.images?.PRIMARY"
                            format="thumbnail"
                            [alt]="product.summary">
                  </cx-media>
                  <h4 class="name" [innerHTML]="getProductName(product)"></h4>
                  <div>
                    <span class="price">{{getPriceLabel(product) | async}} </span>
                    <span *ngIf="product.variantOptions?.length > 1; else elseBlock">
                      <span *ngIf="!product.priceOnRequest">{{product.price?.formattedValue}}</span>
                    </span>
                    <ng-template #elseBlock>
                      <span *ngIf="!product.variantOptions?.[0]?.priceOnRequest">{{product.variantOptions?.[0]?.priceData?.formattedValue}}</span>
                    </ng-template>
                  </div>
                </a>
              </li>
            </ul>

          </div>
        </div>

      </div>

    </div>
  </ng-container>
</div>
